import { withStyles } from "@material-ui/styles";
import { Button } from "@material-ui/core";

export const BotonPrincipal = withStyles((theme) => ({
    root: {
        padding: "10px",
        minWidth: "210px",
        height: "38px",
        background: "#02A48D",
        color: "white",
        borderRadius: "8px",
        fontWeight: "500",
        fontSize: "15px",
        lineHeight: "20.75px",
        boxShadow: "0px 7px 26px rgba(2, 89, 158, 0.15)",
        "&:disabled": {
            background: "#A8E9DF",
            color: "white",
        },
        "&:focus": {
            outline: "none",
        },
        "&:hover": {
            background: "#00baa4",
        },
    },
}))(Button);

export const BotonFiltro = withStyles((theme) => ({
    root: {
        padding: "10px",
        minWidth: "110px",
        height: "38px",
        background: "#02599E",
        color: "white",
        borderRadius: "8px",
        fontWeight: "500",
        fontSize: "15px",
        lineHeight: "20.75px",
        boxShadow: "0px 7px 26px rgba(2, 89, 158, 0.15)",
        "&:disabled": {
            background: "#02599E",
            color: "white",
        },
        "&:focus": {
            outline: "none",
        },
        "&:hover": {
            background: "#02599E",
        },
    },
}))(Button);

export const BotonSecundario = withStyles((theme) => ({
    root: {
        height: "38px",
        padding: "10px 20px",
        border: "1px solid #02A48D",
        boxSizing: "border-box",
        filter: "drop-shadow(0px 7px 26px rgba(2, 89, 158, 0.15))",
        borderRadius: "8px",
        color: "#02A48D",
        fontWeight: "500",
        fontSize: "15px",
        lineHeight: "20.75px",
        "&:focus": {
            outline: "none",
        },
    },
}))(Button);

export const BotonLink = withStyles((theme) => ({
    root: {
        padding: "10px 20px",
        border: "0px",
        borderRadius: "8px",
        color: "#02599E",
        fontWeight: "normal",
        fontSize: "15px",
        lineHeight: "21px",
        letterSpacing: "-0.72px",
        backgroundColor: "transparent",
        "&:focus": {
            outline: "none",
        },
    },
}))(Button);
